import { Flame, Trophy } from "lucide-react";

// Compact side-by-side badges for current + best streak.
// - Current streak: flame + orange
// - Best streak: trophy + amber, with a subtle record glow when current >= best (and > 0)
export default function StreakBadges({ current = 0, best = 0, className = "", size = "sm" }) {
  const atRecord = current > 0 && current >= best;
  const iconSize = size === "lg" ? "w-5 h-5" : "w-3.5 h-3.5";
  const textSize = size === "lg" ? "text-lg" : "text-sm";

  return (
    <div
      className={`inline-flex items-center gap-2 ${className}`}
      data-testid="streak-badges"
      title={`Current streak: ${current} · Best streak: ${best}`}
    >
      <span
        className={`inline-flex items-center gap-1 font-mono-stat font-bold text-orange-300 ${textSize}`}
        data-testid="badge-current-streak"
      >
        <Flame className={iconSize} />
        <span>{current}</span>
      </span>
      <span aria-hidden className="text-slate-600 select-none">·</span>
      <span
        className={`inline-flex items-center gap-1 font-mono-stat font-bold text-amber-300 ${textSize} ${atRecord ? "streak-record-glow" : ""}`}
        data-testid="badge-best-streak"
      >
        <Trophy className={iconSize} />
        <span>{best}</span>
      </span>
    </div>
  );
}
